import { LogoMark, LogoWord } from "../Logo";

export default function Footer() {
  return (
    <footer className="border-t border-[#2E333D] bg-[#0C0D0E] py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <LogoMark size={28} />
              <LogoWord />
            </div>
            <p className="mt-4 text-sm text-gray-500 max-w-sm leading-relaxed">
              Boîte de rangement connectée pour professionnels.
              Produit actuellement en développement — visuels non contractuels.
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm" aria-label="Liens légaux">
            <a href="/mentions-legales" data-testid="footer-link-mentions" className="text-gray-400 hover:text-[#FFC700] transition-colors">Mentions légales</a>
            <a href="/politique-confidentialite" data-testid="footer-link-confidentialite" className="text-gray-400 hover:text-[#FFC700] transition-colors">Politique de confidentialité</a>
            <a href="/politique-cookies" data-testid="footer-link-cookies" className="text-gray-400 hover:text-[#FFC700] transition-colors">Politique cookies</a>
            <a href="/admin" data-testid="footer-link-admin" className="text-gray-600 hover:text-[#FFC700] transition-colors">Administration</a>
          </nav>
        </div>
        <div className="mt-10 pt-6 border-t border-[#2E333D]/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-600">© {new Date().getFullYear()} STOCKBOX 8. Tous droits réservés.</p>
          <p className="font-mono text-[10px] uppercase tracking-widest text-gray-700">Pré-lancement — France</p>
        </div>
      </div>
    </footer>
  );
}
